export const features = {
  chatbot: "chatbot",
  taskManagement: "taskManagement"
};

const GLOBME = "07ab0e73-f8ea-429e-9a35-76b3e25fa2ac";

const featureFlags = {
  [features.chatbot]: {
    enabled: false,
    beta: false,
    betaOrganizations: [GLOBME]
  },
  [features.taskManagement]: {
    enabled: true,
    beta: false,
    betaOrganizations: [GLOBME]
  }
};

export const isFeatureEnabled = (featureName, organizationId) => {
  const feature = featureFlags[featureName];

  if (!feature || !feature.enabled) return false;

  return !feature.beta || feature.betaOrganizations.includes(organizationId);
};
